import { render, staticRenderFns } from "./a-html-minimal.vue?vue&type=template&id=3ab0ca68&"
import script from "./a-html-minimal.vue?vue&type=script&lang=js&"
export * from "./a-html-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports